/**
 * ViewToggle — Kart / Liste görünüm anahtarı (Grid3x3 · LayoutList ikonları).
 *
 * Kullanım:
 *   <ViewToggle value={view} onChange={setView} testId="customers-view" />
 */
import { Grid3x3, LayoutList } from "lucide-react";

export default function ViewToggle({ value, onChange, testId = "view" }) {
  return (
    <div className="flex bg-slate-900 border border-slate-800 rounded-sm p-0.5 shrink-0" role="tablist" aria-label="Görünüm">
      <button
        type="button"
        data-testid={`${testId}-grid`}
        onClick={() => onChange("grid")}
        title="Kart Görünümü"
        aria-pressed={value === "grid"}
        className={`h-7 w-7 rounded-sm flex items-center justify-center transition-colors ${
          value === "grid"
            ? "bg-blue-600 text-white"
            : "text-slate-400 hover:text-slate-100"
        }`}
      >
        <Grid3x3 className="w-3.5 h-3.5" strokeWidth={2} />
      </button>
      <button
        type="button"
        data-testid={`${testId}-list`}
        onClick={() => onChange("list")}
        title="Liste Görünümü"
        aria-pressed={value === "list"}
        className={`h-7 w-7 rounded-sm flex items-center justify-center transition-colors ${
          value === "list"
            ? "bg-blue-600 text-white"
            : "text-slate-400 hover:text-slate-100"
        }`}
      >
        <LayoutList className="w-3.5 h-3.5" strokeWidth={2} />
      </button>
    </div>
  );
}
